const InputTableHeader = ({ settingsData, headrailConfig, order }) => {
  const additionalColumns = headrailConfig?.formulas || [];

  // const shouldShowLiftStyle = order.some((row) => row.width && row.height);
  return (
    <thead className="table-header-custom">
      <tr>
        <th className="border-end text-uppercase" style={{ width: "120px" }}>
          Index
        </th>
        <th className="border-end text-uppercase" style={{ width: "120px" }}>
          Width <span style={{ color: "red" }}>*</span>
        </th>
        <th className="border-end text-uppercase" style={{ width: "120px" }}>
          Height <span style={{ color: "red" }}>*</span>
        </th>
        <th className="border-end text-uppercase" style={{ width: "90px" }}>
          Lift Style <span style={{ color: "red" }}>*</span>
        </th>

        {settingsData?.showLocation && (
          <th className="border-end text-uppercase" style={{ width: "150px" }}>
            Location
          </th>
        )}
        {settingsData?.showRemark && (
          <th className="border-end text-uppercase" style={{ width: "150px" }}>
            Remarks
          </th>
        )}
        {settingsData?.showControl && (
          <th className="border-end text-uppercase" style={{ width: "150px" }}>
            Control
          </th>
        )}
        {settingsData?.showMountLift && (
          <th className="border-end text-uppercase" style={{ width: "150px" }}>
            Lift
          </th>
        )}
        {settingsData?.showTile && (
          <th className="border-end text-uppercase" style={{ width: "150px" }}>
            Tile
          </th>
        )}
        {additionalColumns.map((column) => (
          <th
            key={column.key}
            className="border-end text-uppercase"
            style={{ width: "120px" }}
          >
            {column.key}
          </th>
        ))}
        <th className="border-end text-uppercase" style={{ width: "90px" }}>
          Sqft
        </th>
        <th className="border-end text-uppercase" style={{ width: "120px" }}>
          Add
        </th>
        <th className="border-end text-uppercase" style={{ width: "120px" }}>
          Split Calc
        </th>
        <th className="border-end text-uppercase" style={{ width: "120px" }}>
          Delete
        </th>
      </tr>
    </thead>
  );
};

export default InputTableHeader;
